'use strict';

import React from 'react';

require('styles//Header.css');

let logo = require('../images/logo.gif');
let icon1 = require('../images/icon1.gif');
let icon2 = require('../images/icon2.gif');
//let icon3 = require('../images/icon2.gif');


class HeaderComponent extends React.Component {
  render() {
    return (
      <div className="header-component" id="header">
       <a className="linkOld" href="http://old.medinfo.kz">Старая версия сайта</a>
       <ul className="list">
          <li><a href="#/home"><img src={icon1} alt="" /></a></li>
          <li className="last"><a href="#/contact"><img src={icon2} alt="" /></a></li>
        </ul>
        <ul className="site-nav">
          <li><a href="#/home">Главная</a></li>
		      <li><a href="#/stats">Мед.статистика</a></li>
          <li><a href="#/apps">Наши разработки</a></li>
          <li><a href="#/archives">Архивы программ</a></li>
          <li className="last"><a href="#/contact">Контакты</a></li>
        </ul>
        <div className="logo"><a href="#/home"><img src={logo} alt="" /></a></div>
      </div>
    );
  }
}

HeaderComponent.displayName = 'HeaderComponent';

// Uncomment properties you need
// HeaderComponent.propTypes = {};
// HeaderComponent.defaultProps = {};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/HeaderComponent.js